export const getDateFromTimestamp = (timestamp: string) => new Date(+timestamp * 1000);
export const getMillisecFromTimestamp = (timestamp: string) => +timestamp * 1000;
export const isPastTimestamp = (timestamp: string) => +timestamp * 1000 < Date.now();
export const isFutureTimestamp = (timestamp: string) => +timestamp * 1000 > Date.now();
